import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AfterViewInit, Component, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import moment from 'moment-timezone';

const UTC_EDP_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
const UTC_EDP_OUTPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
@Component({
  selector: 'miq-ag-date',
  templateUrl: './ag-date.component.html',
  styleUrls: ['./ag-date.component.scss'],
  standalone: false,
})
export class AgDateComponent implements ICellEditorAngularComp, AfterViewInit, OnDestroy {
  params: any;
  currentValue: any;
  column: any;
  placeholder = 'SELECT DATE';

  private focusWhenCreate = false;

  fc: UntypedFormControl;
  @ViewChild('input', { read: ViewContainerRef, static: false }) public input;

  /**
   * Required by ICellEditorAngularComp
   */
  agInit(params: any) {
    this.params = params;
    this.currentValue =
      params.value && moment(params.value).isValid() ? moment(params.value, UTC_EDP_INPUT_FORMAT).utc() : null;
    const paramsObject =
      typeof params?.cellEditorParams === 'function' ? params?.cellEditorParams(params) : params?.cellEditorParams;
    this.column = params.colDef;
    this.focusWhenCreate = !!params.focusWhenCreate || paramsObject?.focusWhenCreate;
  }

  onDateChange(event: Date) {
    const dateValue = event;
    this.currentValue = dateValue && moment(dateValue).isValid() ? moment(dateValue, UTC_EDP_INPUT_FORMAT).utc() : null;
    const columnDef = this.params.api.getColumnDef(this.column.field);
    if (columnDef) {
      this.params?.node?.setDataValue?.(this.column.field, this.currentValue);
    } else {
      // Fallback and use the column id field
      this.params?.node?.setDataValue?.(this.column.colId, this.currentValue);
    }
  }

  ngOnDestroy() {
    this.input = null;
  }

  /**
   * Required by ICellEditorAngularComp
   */
  ngAfterViewInit() {
    if (this.focusWhenCreate) {
      setTimeout(() => this.input.element.nativeElement.focus());
    }
  }

  /**
   * Required by ICellEditorAngularComp
   */
  getValue() {
    return this.currentValue ? this.currentValue.format(UTC_EDP_OUTPUT_FORMAT) : this.currentValue;
  }
}
